export default {

    recipientContainer: {
        width: "100%",
        padding: "20px 20px 0px 20px",
        flex: "1 1 0%"
    },

    container: {
        marginTop: "20px",
        width: "60%"
    },

    footerText: {
        fontWeight: "700",
        fontSize: "16px",
        color: "#215DAA"
    },

    cardsGroupContainer: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        gap: "30px",
        margin: "40px 0px",
    },

    cardContainer: {
        cursor: "pointer",
    },

    individualCardStyle: {
        height: "315px",
        width: "230px",
    },

    formContainer: {
        marginTop: "40px",
        display: "flex",
        flexDirection: "column",
        rowGap: "30px",
    },

    addPayerSuccessContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        height: "100%"
    },

    cardHeading: {
        marginTop: "20px",
        width: "57%",
        textAlign: "center",
    },

    cardSubHeading: {
        marginTop: "10px",
        fontWeight: "normal",
        width: "57%",
        textAlign: "center",
    },

    grayBorder: {
        borderBottom: "0.5px solid #959AAA",
        width: "80%",
        margin: "20px 0px"
    },

    payerName: {
        fontWeight: "500",
        fontSize: "20px",
        color: "#252323",
    },

    questionText: {
        fontSize: "20px",
        color: "#252323",
        marginTop: "50px"
    },

    buttonsContainer: {
        display: "flex",
        columnGap: "20px",
    },

    button: {
        padding: "8px 20px"
    },

    popupStyles: {
        borderRadius: "0px",
        maxWidth: "unset",
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
    },

    popupoOverlay: {
        background: "transparent",
        position: "fixed",
        top: "calc(50% + 36px)",
        left: "calc(50% + 40px)",
        transform: "translate(-50%, -50%)",
        transition: "all 0.5s ease-in-out 0s",
        width: "calc(100vw - 78px)",
        height: "calc(100vh - 72px)",
        zIndex: 998,
    },

    popupChildrenStyles: {
        maxHeight: "unset",
        height: "100%",
        overflowY: "auto",
        display: "flex",
    }

}